export const smoothScrollToTop = () => {
	const currentPosition = window.pageYOffset;
	if (currentPosition > 0) {
		window.requestAnimationFrame(smoothScrollToTop);
		window.scrollTo(0, currentPosition - currentPosition / 8);
	}
};
